<template lang="pug">
div
  v-layout(align-center)
    span(style='width: 240px') Websiteprofiel

    text-field(
      v-if='readonly',
      hide-details,
      v-model='domain',
      :readonly='true',
      :disabled='true'
      )

    v-autocomplete(
      v-else
      v-model='domain',
      :items='websites',
      item-text='name',
      item-value='domain',
      solo,
      hide-details,
      placeholder='Typ hier om een websiteprofiel te zoeken'
      )

  v-alert.mt-4(v-model='showTestmodeWarning', type='warning') Dit websiteprofiel is in test-modus. Deze aanvraag zal als test gemarkeerd worden en zal niet geëxporteerd worden. De aanvrager zal wel een bevestigings e-mail ontvangen.

</template>

<script>
export default {
  props: {
    value: String,
    readonly: {
      type: Boolean,
      default: true
    },
    isBusinessLease: {
      type: Boolean
    }
  },

  data () {
    return {
      domain: this.value,
      websites: []
    }
  },

  computed: {
    selectedWebsite () {
      return this.websites.find(x => x.domain === this.domain)
    },

    showTestmodeWarning () {
      return this.selectedWebsite ? this.selectedWebsite.state === 'testmode' : false
    }
  },

  async created () {
    this.websites = await this.$store.dispatch('graphqlQuery', {
      name: this.isBusinessLease ? 'getBusinessLeaseWebsites' : 'getPrivateLeaseWebsites',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      }
    })

    // Filter websites without id cause they are added in the domain filter as "All websites"
    this.websites = this.websites.filter(x => x.id).filter(x => x.state !== 'disabled')

    this.websites.forEach(x => {
      x.name = x.name + (x.state === 'testmode' ? ' (test-modus)' : '')
    })

    if (this.websites.length === 1) {
      this.domain = this.websites[0].domain
    }
  },

  watch: {
    value (v) {
      this.domain = v
    },

    domain (v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
